<template>
  <v-text-field
    :label="metadata.title"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
  ></v-text-field>
</template>

<script>
  export default {
    name: "MetaFieldText",

    props: [
      'value',
      'metadata'
    ],

    data: () => ({
    }),

    methods: {
    }
  }
</script>
